import { render, staticRenderFns } from "./OrderSecondStepComponent.vue?vue&type=template&id=f8a28cfc"
import script from "./OrderSecondStepComponent.vue?vue&type=script&lang=js"
export * from "./OrderSecondStepComponent.vue?vue&type=script&lang=js"
import style0 from "./OrderSecondStepComponent.vue?vue&type=style&index=0&id=f8a28cfc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports